<div *ngIf="osType">
  <div class="stick-top">
    <mat-toolbar
      ><mat-icon>extension</mat-icon>
      {{ osType.id ? "OS Type - " + osType.name : "Create new OS Type" }}</mat-toolbar
    >
    <div class="hbox lightly-padded button-bar">
      <button
        mat-raised-button
        class="primary"
        type="button"
        (click)="save()"
        [disabled]="!form.form.valid || !osType.companyId"
      >
        <mat-icon>{{ osType.id ? "save" : "add" }}</mat-icon>
        {{ osType.id ? "Update" : "Add" }}
      </button>
      <micro-delete-confirm
        *ngIf="osType.id"
        (onConfirm)="delete()"
      ></micro-delete-confirm>
    </div>
  </div>
  <div class="padded">
    <form #form="ngForm" role="form">
      <table class="basicTable vtable">
        <thead>
          <tr>
            <th colspan="100">OS Type Details</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="auth.isCompanyAdmin()">
            <th>
              <micro-valid-label
                for="companyId"
                [model]="osType.companyId"
                label="Company"
              ></micro-valid-label>
            </th>
            <td>
              <micro-company-select
                [(companyId)]="osType.companyId"
                [required]="true"
              ></micro-company-select>
            </td>
          </tr>
          <tr>
            <th>
              <micro-valid-label
                for="code"
                [model]="code"
                label="Code"
              ></micro-valid-label>
            </th>
            <td>
              <input
                #code="ngModel"
                [(ngModel)]="osType.code"
                required
                maxlength="32"
                id="code"
                name="code"
              />
            </td>
          </tr>
          <tr>
            <th>
              <micro-valid-label
                for="name"
                [model]="name"
                label="Name"
              ></micro-valid-label>
            </th>
            <td>
              <input
                #name="ngModel"
                [(ngModel)]="osType.name"
                required
                maxlength="50"
                id="name"
                name="name"
              />
            </td>
          </tr>
          <tr>
            <th>
              <micro-valid-label
                for="description"
                [model]="description"
                label="Description"
              ></micro-valid-label>
            </th>
            <td>
              <input
                #description="ngModel"
                [(ngModel)]="osType.description"
                required
                maxlength="50"
                id="description"
                name="description"
              />
            </td>
          </tr>
          <tr>
            <th [ngClass]="osType.active !== 'Y' ? 'CRITICAL' : ''">
              <micro-valid-label
                for="active"
                label="Active"
              ></micro-valid-label>
            </th>
            <td>
              <input
                type="checkbox"
                [checked]="osType.active === 'Y'"
                (change)="onCheckboxChange($event)"
                id="active"
                name="active"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </form>
  </div>
</div>
